/** A small inline page icon: the strip is in the first load, so no icon library here. */
export function DocumentIcon({ size = 20 }: { size?: number }) {
  return (
    <svg
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      aria-hidden="true"
    >
      <path d="M6 3h8l4 4v14H6zM14 3v4h4M9 13h6M9 17h6" />
    </svg>
  );
}
